/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');

const Q_most_single_target_damage = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  // _branches indexes
  node.MELEE_ATTACK = 0;
  node.BURNING_HANDS = 1;
  node.SKY_HAMMER = 2;
  node.SLAM = 3;

  node.burningHands = BattleCalc.getEquippedAbility(actor, 'burning_hands');
  node.meleeAttack = BattleCalc.getEquippedAbility(actor, 'melee_attack');
  node.mysticFocus = BattleCalc.getEquippedAbility(actor, 'mystic_focus');
  node.skyHammer = BattleCalc.getEquippedAbility(actor, 'sky_hammer');
  node.slam = BattleCalc.getEquippedAbility(actor, 'slam');

  if (node.burningHands) {
    node.branches[node.BURNING_HANDS] = new UseAbility(actor, 'burning_hands');
  }

  node.branches[node.MELEE_ATTACK] = new UseAbility(actor, 'melee_attack');
  node.branches[node.SKY_HAMMER] = new UseAbility(actor, 'sky_hammer');
  node.branches[node.SLAM] = new UseAbility(actor, 'slam');

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.burningHands = null;
    node.meleeAttack = null;
    node.mysticFocus = null;
    node.skyHammer = null;
    node.slam = null;
    originalDispose.call(node);
  };

  node.query = function (target) {
    // small chance to use sky hammer
    if (this.skyHammer && Math.random() < 0.333) {
      var adjacentTiles = this.battleState.getAdjacentTiles(target);
      return this.branches[this.SKY_HAMMER].query(
        adjacentTiles[Math.floor(Math.random() * adjacentTiles.length)]
      );
    }

    // chance to use slam
    if (
      this.slam &&
      !BattleCalc.targetIsAtBoardEdge(actor, target, battleState) &&
      Math.random() < 0.333
    ) {
      return this.branches[this.SLAM].query(target);
    }

    const setTopDamageToBurningHands = () => {
      if (
        this.burningHands &&
        (this.actor.mp >= this.burningHands.mpCost ||
          (this.mysticFocus && this.actor.mp >= this.mysticFocus.mpCost))
      ) {
        return this.burningHands.damage;
      } else {
        return 0;
      }
    };
    var _topDamage = setTopDamageToBurningHands();

    if (this.meleeAttack && this.meleeAttack.damage > _topDamage) {
      return this.branches[this.MELEE_ATTACK].query(target);
    } else if (this.burningHands) {
      return this.branches[this.BURNING_HANDS].query(target);
    } else {
      return null;
    }
  };

  return node;
};
module.exports = Q_most_single_target_damage;
